import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=7cece8b0&scoped=true"
import script from "./VideoDetails.js?vue&type=script&lang=js&external"
export * from "./VideoDetails.js?vue&type=script&lang=js&external"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=7cece8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cece8b0",
  null
  
)

export default component.exports